module.exports = __webpack_public_path__ + "static/jquery-book-bac0fb4bd9cc0e546b03355307ec6d53.png";